import * as React from 'react';
const Markdown = require('react-commonmark');

const SignPostingText = ({ isCalculating, content }) => {
  if (isCalculating || !content) {
    return null;
  }
  return (
    <div className={'signposting--textbox'}>
      <Markdown source={content} linkTarget="_blank" />
    </div>
  );
};

export default SignPostingText;
